import {useEffect, useState} from 'react'

import {Formik, Form, Field} from 'formik'
import BootstrapModal from '../../components/BootstrapModal';
import * as Yup from "yup";
import TextField from "../../components/TextField";
import PMSCheckBox from "../../components/PMSCheckBox";
import {ProgressSpinner} from "primereact/progressspinner";

const AssessmentOpinionForm = ({
                                   modal,
                                   assestmentOpinionID,
                                   title,
                                   titleBangla,
                                   active,
                                   isLoading,
                                   onSubmit,
                                   onHide
                               }) => {

    const validation = Yup.object({
        title: Yup.string().required(),
        titleBangla: Yup.string().required()
    })

    return (

        <BootstrapModal headerText="Add Assessment Opinion" size={30} visible={modal} onHide={onHide}>
            <Formik
                validationSchema={validation}
                initialValues={{
                    assestmentOpinionID: assestmentOpinionID,
                    title: title,
                    titleBangla: titleBangla,
                    active: active,
                }}
                onSubmit={onSubmit}>
                {formik =>
                    (<Form>
                            <Field type="hidden" name="assestmentOpinionID"/>
                            <TextField label={'title'} type="text" name="title"/>
                            <TextField label={'title Bangla'} type="text" name="titleBangla"/>
                            <PMSCheckBox label={'Active'} name={'active'} id={'active'}/>
                            {isLoading ? <ProgressSpinner style={{height: 30, width: 30}}/> :
                                <button type="submit" disabled={isLoading}
                                        className="btn btn-primary">{assestmentOpinionID === 0 ? 'Save' : 'Update'} </button>}

                        </Form>
                    )}
            </Formik>


        </BootstrapModal>
    )
}


export default AssessmentOpinionForm